import { Result } from 'services/Result';
import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';
import { LogService } from 'services/LogService';
import { ISecondSourcePlay } from 'interfaces/secondSourceBox/ISecondSourcePlay';
import { notify } from 'services/NotificationService';

interface PTResult {
  plays: ISecondSourcePlay[];
}

@injectable()
export class SecondSourceService {
  private axiosInstance: AxiosInstance;

  private logService: LogService;

  noDataReceived = false;

  constructor(axiosInstance: AxiosInstance, logService: LogService) {
    this.axiosInstance = axiosInstance;
    this.logService = logService;
  }

  fetchSecondSourceData = async (sessionId: string): Promise<PTResult | void> => {
    try {
      const response = await this.axiosInstance.get<Result<PTResult>>(`api/boxscore/SecondSource/${sessionId}/PlayerTracking`);
      if (response.data && !response.data.isError && response.data.data) {
        this.noDataReceived = false;
        return response.data.data;
      }
      throw Error(JSON.stringify(response));
    } catch (err: unknown) {
      if (err instanceof Error) {
        notify('Error', err.message, 'error');
      }
    }
  };
}
